module.exports = __webpack_public_path__ + "img/e751af607c4abe2e58d698d941457ec8.svg";